import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ap9qto2o: FaireBrandEntity = {
  token: "b_ap9qto2o",
  type: "brand",
  name: "Abrams",
  avatarUrl:
    "https://cdn.faire.com/fastly/84f6de672935699e23951b6a5e3af6180525d3846574cc0dfc546a93b24ff6c6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ed0044968593b0529aa6ea29496b84dcc8ec31b969b71ee1c3a8e3a5a549ac78.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/84f6de672935699e23951b6a5e3af6180525d3846574cc0dfc546a93b24ff6c6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ed0044968593b0529aa6ea29496b84dcc8ec31b969b71ee1c3a8e3a5a549ac78.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 103,
  rating: 4.9,
  reviewCount: 206,
  isTopShop: true,
  isInsider: true,
  description:
    "ABRAMS makes books that reflect our commitment to the image and the word, to design and storytelling. We practice the art of books. At the heart of this practice are people—creators, colleagues, partners, and readers—who together form a passionate community committed to quality and integrity. We strive to be inclusive in our publishing and our organization and to celebrate a diverse array of voices, cultures, and ideas.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:02.084Z",
    importedBy: "entity-db-cli",
  },
};
